import React, { useEffect, useState } from "react";
import {
    IonLabel,
    IonIcon,
    IonButton,
    IonCard,
    IonModal,
    IonContent,
    IonList,
    IonItemSliding,
    IonItemOptions,
    IonItemOption,
} from "@ionic/react";
import { trash } from "ionicons/icons";
import { Capacitor } from "@capacitor/core";
import database from "../Database";
import { SitePhoto } from "../models/SitePhoto";
import SitePhotoItem from "./SitePhotoItem";
import { User } from "../models/User";

// import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

interface Props {
    sitePhotos?: SitePhoto[];
    onSitePhotoDeleted: (sitePhotoId: string) => void;
    isReadOnly: boolean;
    permitId: string;
    projectUsers?: User[];
}

export interface SitePhotoInfo extends SitePhoto {
    filePath: String;
}

const SitePhotosList: React.FC<Props> = ({ sitePhotos, permitId, onSitePhotoDeleted, isReadOnly, projectUsers }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedPhotoPath, setSelectedPhotoPath] = useState("");
    const [sitePhotoInfos, setSitePhotoInfos] = useState([] as Array<SitePhotoInfo>);

    useEffect(() => {
        const photos: Array<SitePhotoInfo> = [];
        const filePromises: Array<Promise<void>> = [];
        sitePhotos?.forEach((photo) => {
            filePromises.push(
                database.loadPermitFile(permitId, photo.fileKey).then(
                    (result: any) => {
                        if (result) {
                            photos.push({
                                ...photo,
                                filePath: Capacitor.convertFileSrc(result),
                            });
                        }
                    },
                    (err) => {
                        //setFilePath('');
                    }
                )
            );
        });
        Promise.all(filePromises).then(() => {
            setSitePhotoInfos(photos);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sitePhotos]);

    const handlePhotoClick = (filePath: string) => {
        setSelectedPhotoPath(filePath);
        setShowModal(true);
    };

    const renderPhotos = (sitePhotoInfo: SitePhotoInfo) => {
        return (
            <IonItemSliding>
                <SitePhotoItem
                    createdBy={projectUsers?.find((u) => u.id === sitePhotoInfo.createdById)}
                    onClick={handlePhotoClick}
                    sitePhoto={sitePhotoInfo}
                />
                {!isReadOnly && (
                    <IonItemOptions slot="end">
                        <IonItemOption color="danger" expandable={true}>
                            <IonIcon
                                slot="icon-only"
                                icon={trash}
                                onClick={() => onSitePhotoDeleted(sitePhotoInfo.id)}
                            ></IonIcon>
                        </IonItemOption>
                    </IonItemOptions>
                )}
            </IonItemSliding>
        );
    };

    return (
        <>
            <IonModal isOpen={showModal}>
                <IonContent>
                    <IonCard>
                        <img alt="SitePhoto" src={selectedPhotoPath} />
                    </IonCard>
                </IonContent>
                <IonButton onClick={() => setShowModal(false)}>Close</IonButton>
            </IonModal>

            {sitePhotoInfos.length > 0 ? (
                <IonList inset style={{ margin: "0px" }}>
                    {sitePhotoInfos.map(renderPhotos)}
                </IonList>
            ) : (
                <p>
                    <IonLabel style={{ marginLeft: "16px" }} class="ion-text-wrap">
                        There are no photos to display
                    </IonLabel>
                </p>
            )}
        </>
    );
};

export default SitePhotosList;
